module.exports = __webpack_public_path__ + "img/img_thumb_pocket.bfb2179a.png";